import Model, { attr } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';

export default class InvitationModel extends Model {
  declare [Type]: 'invitation';
  @attr declare email: string;
}
